import React, { useState, useEffect } from "react";
import { UserWeddingRole } from "../../types/wedding";

interface LoadingScreenProps {
  userWeddingRole: UserWeddingRole;
  onCountdownEnd?: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ userWeddingRole, onCountdownEnd }) => {
  const isEventPlanner = userWeddingRole === UserWeddingRole.EventPlanner;
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (countdown === 0 && onCountdownEnd) {
      onCountdownEnd();
    }
  }, [countdown, onCountdownEnd]);

  return (
    <div className="fixed top-0 bottom-0 right-0 left-0 w-screen flex flex-col justify-center items-center h-screen bg-gray-100 font-sans">
      <h1 className="text-3xl font-normal mb-8 text-gray-800">
        SETTING UP IN {countdown}...
      </h1>
      <p className="text-base text-gray-600 text-center max-w-md leading-relaxed">
        {isEventPlanner ? (
          <>
            Your dashboard will be everything you've dreamed of
            <br />— and your business, even more successful.
          </>
        ) : (
          <>
            Your wedding will be everything you've dreamed of
            <br />— and your days after, even more beautiful.
          </>
        )}
      </p>
      <p className="text-base text-gray-600 mt-6">
        Please hold while we set up your dashboard.
      </p>
    </div>
  );
};

export default LoadingScreen;
